<script lang="ts">
  import { Hospital } from '../lib/api';
  import BedSemaphoreGrid, { type SemaforoData } from './dashboard/widgets/BedSemaphoreGrid.svelte';

  let data = $state<SemaforoData | null>(null);
  let error = $state<string | null>(null);

  async function cargar() {
    try { data = await Hospital.semaforo(); error = null; }
    catch (e: any) { error = e?.message; }
  }
  $effect(() => { cargar(); const t = setInterval(cargar, 30000); return () => clearInterval(t); });
</script>

<section>
  <header><h2>Semáforo de camas</h2><button type="button" onclick={cargar}>Recargar</button></header>
  {#if error}<p class="err">⚠ {error}</p>{/if}
  <BedSemaphoreGrid {data} showTables={true} />
</section>

<style>
  header { display: flex; justify-content: space-between; align-items: center; }
  header button { padding: 0.45rem 0.8rem; border: 0; background: var(--brand); color: #fff; border-radius: 8px; cursor: pointer; }
  h2 { margin: 0; color: var(--text-primary); }
  .err { color: var(--danger); }
</style>
